import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path:'/users',
      name: 'users',
      component: () => import ('./views/Users.vue')
    },
    {
      path:'/clients',
      name: 'clients',
      component: () => import ('./views/Clients.vue')
    },
    {
      path: '/files',
      name: 'Files',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Spend" */ './views/Files.vue')
    },
    {
      path: '/',
      redirect: '/files'
    }
  ]
})
